import { Image, UIHeading4, UIHeading5 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { type FC } from 'react';

import { AdLabel } from 'shared/components/AdLabel';
import { MortgageAnnotations } from 'shared/components/MortgageAnnotations';
import { Ticker } from 'shared/components/Ticker';
import { toCssImageUrl } from 'shared/utils/toCssImageUrl';

import { TGetTgbNativedescGeneralCompleteContextResult } from '../../../../utils/getTgbNativedescGeneralCompleteContext';

import styles from './TgbNativedescGeneralMobileListing.css';

export type TTgbNativedescGeneralMobileListingProps = {
  completeContext: TGetTgbNativedescGeneralCompleteContextResult;
};

export const TgbNativedescGeneralMobileListing: FC<TTgbNativedescGeneralMobileListingProps> = ({
  completeContext: {
    title,
    annotation,
    image,
    url,
    label,
    logoImageUrl,
    description,
    sizes: { height },
    mortgageWarning,
    mortgageTermsWarning,
  },
}) => {
  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  return (
    <a
      data-testid="tgb-nativedesc-general-mobile-listing"
      href={url}
      style={{ height }}
      target="_blank"
      className={clsx(styles['container'], withMortgageAnnotations && styles['container--mortgage-annotations'])}
      rel="noopener noreferrer"
    >
      <div className={styles['photo-block']} style={{ backgroundImage: toCssImageUrl(image) }}>
        {!!label && (
          <div className={styles['photo-label']}>
            <AdLabel label={label} />
          </div>
        )}
        {!!annotation && (
          <div className={styles['annotation']}>
            <Ticker theme="dark-background" text={annotation} />
          </div>
        )}
      </div>
      <div className={styles['content']}>
        <div className={styles['title-container']}>
          <UIHeading4>{title}</UIHeading4>
          {!!description && <UIHeading5>{description}</UIHeading5>}
        </div>
        {!!logoImageUrl && (
          <div className={styles['logo-container']}>
            <Image src={logoImageUrl} borderRadius="4px" width={40} height={40} objectFit="contain" />
          </div>
        )}
      </div>
      {withMortgageAnnotations && (
        <div className={styles['mortgage-disclaimer']}>
          <MortgageAnnotations
            height={height}
            mortgageWarning={mortgageWarning}
            mortgageTermsWarning={mortgageTermsWarning}
          />
        </div>
      )}
    </a>
  );
};
